const baseUrl = process.env.VUE_APP_API_URL || 'https://test-chorus-engine.rainbird.ai:443';

const appmixer = new window.Appmixer({ baseUrl });

export default appmixer;
